<template>
  <div>
    <div
      class="relative flex"
      :class="description === ''? 'items-center' : 'items-start' "
    >
      <div class="flex items-center">
        <Checkbox
          :value="value"
          @change="changeValue"
        />
      </div>
      <div
        v-if="displayInfo"
        class="ml-3 text-sm leading-5"
      >
        <label
          class="font-medium text-gray-700"
          :class="description === ''? 'mt-2' : '' "
        >{{ title }}</label>
        <p
          v-if="description !== ''"
          class="text-gray-500"
        >
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from './checkbox.vue';

export default {

  components: {
    Checkbox,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    displayInfo: {
      type: Boolean,
      default: true,
    },
    defaultValue: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      value: true,
    };
  },

  watch: {
    value() {
      this.$emit('change', {
        title: this.title,
        value: this.value,
      });
    },
    defaultValue(newValue) {
      // Update value when defaultValue prop changes
      this.value = newValue;
    },
  },

  created() {
    this.value = this.defaultValue;
  },

  methods: {
    changeValue(value) {
      this.value = value.state;
    },
  },

};
</script>
